/**
* @description Interface for Bygghemma.Web.Models.EnticementType
*/
export const enum EnticementType {
  None = 0,
  Popular,
  BestSelling,
  Trending,
  LimitedOffer,
}